import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { map } from 'rxjs/operators';
import { CampaignOffersState, CampaignOffersStore } from './campaign-offers.store';

@Injectable({ providedIn: 'root' })
export class CampaignOffersQuery extends QueryEntity<CampaignOffersState> {
  constructor(protected store: CampaignOffersStore) {
    super(store);
  }

  selectAllCampaignOffers() {
    return this.selectAll().pipe(
      map((campaignOffers) => {
        return campaignOffers;
      })
    );
  }
}
